// extracted by mini-css-extract-plugin
export default {"switch-group":"switchGroup_switch-group__laKuA","switch-group--stats":"switchGroup_switch-group--stats__Ol2pe"};